module.exports = __webpack_public_path__ + "static/img/RE.6501d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE.jpg
// module id = EqJX
// module chunks = 0